import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { PlatformComponentsModule } from '@ecap3/app-platform-core-components';
import { NoDataFoundComponent } from './components/no-data-found/no-data-found.component';

@NgModule({
    imports: [
        TranslateModule.forChild(),
        FlexLayoutModule.withConfig({
            useColumnBasisZero: false,
            printWithBreakpoints: ['xs', 'sm', 'md', 'lg', 'xl', 'lt-sm', 'lt-md', 'lt-lg', 'lt-xl', 'gt-xs', 'gt-sm', 'gt- md', 'gt-lg']
        }),
        MatButtonModule,
        MatIconModule,
        CommonModule,
        PlatformComponentsModule
    ],
    exports: [
        NoDataFoundComponent
    ],
    declarations: [
        NoDataFoundComponent
    ],
    providers: [
    ]
})
export class PlatformNoDataFoundModule { }
